import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeneratedAnswer } from '@wix/ambassador-cc-helpcenter-v1-generated-answer/types';

import { IGenerateAnswerState } from './types';

const initialState: IGenerateAnswerState = {
  query: '',
  error: null,
  isLoading: false,
  answer: null,
  prohibited: false,
  usedArticlesInfo: {},
};

export const generateAnswerSlice = createSlice({
  name: 'generateAnswer',
  initialState,
  reducers: {
    resetGenerateAnswer: (_state, action: PayloadAction<string>) => ({
      ...initialState,
      query: action.payload || '',
    }),
    startStreamingAnswer: (_state, action: PayloadAction<string>) => {
      return {
        ...initialState,
        query: action.payload,
        error: null,
        isLoading: true,
        answer: null,
        usedArticlesInfo: {},
        prohibited: false,
      };
    },
    appendAnswerChunk: (state, action: PayloadAction<string>) => {
      const currentAnswer = state.answer || '';
      return {
        ...state,
        answer: currentAnswer + action.payload,
      };
    },
    updateStreamingAnswer: (state, action: PayloadAction<GeneratedAnswer>) => {
      const answerStr = action.payload?.answer;
      let answer: any = {};
      try {
        answer = answerStr ? JSON.parse(answerStr) : {};
      } catch (e) {
        answer = {};
      }
      return {
        ...state,
        answer: answer.solution || '',
        query: answer.search_term || '',
        prohibited: action.payload?.prohibited ?? false,
        usedArticlesInfo: action.payload?.metadata?.usedArticlesInfo ?? {},
        isLoading: false,
        error: null,
      };
    },
    failStreamingAnswer: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        answer: '',
      };
    },
  },
});
